
export const calculateFundingFee = (
  loanType: string,
  loanAmount: number,
  homePrice: number,
  downPayment: number,
  downPaymentPercentage: number,
  isFirstTimeHomebuyer: boolean,
  vaStatus?: string | null,
  homebuyingHistory?: string | null,
  vaDisabilityStatus?: string | null
) => {
  if (loanType === 'va') {
    // VA funding fee calculation
    if (vaDisabilityStatus === 'partial' || vaDisabilityStatus === 'full') {
      return { percentage: 0, amount: 0 };
    }
    
    let feePercentage = 2.3; // Default VA funding fee
    
    if (vaStatus === 'activeDuty') {
      feePercentage = 2.15;
    }
    
    if (homebuyingHistory === 'firstTime') {
      feePercentage = 2.15;
    } else if (homebuyingHistory === 'other') {
      feePercentage = 3.3;
    }
    
    const amount = loanAmount * (feePercentage / 100);
    return { percentage: feePercentage, amount };
  }
  
  if (loanType === 'fha') {
    // FHA upfront MIP is 1.75%
    const amount = loanAmount * 0.0175;
    return { percentage: 1.75, amount };
  }
  
  if (loanType === 'usda') {
    // USDA guarantee fee is 1.0%
    const amount = loanAmount * 0.01;
    return { percentage: 1.0, amount };
  }
  
  // Conventional loans don't have funding fees
  return { percentage: 0, amount: 0 };
};
